import { SxProps } from '@mui/material'

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: '#FBF5F1',
  },
  content: {
    flex: 1,
    marginTop: 10,
    paddingTop: { xs: 2, md: 3 },
    px: { xs: 4, md: 6 },
  },
} satisfies SxProps
